import React from 'react';
import styled from 'styled-components';

interface BurgerButtonProps {
  readonly open: boolean;
  onClick: any
};

interface StyledBurgerButtonProps {
  readonly open: boolean;
};

export const StyledBurgerButton = styled.button<StyledBurgerButtonProps>`
  position: absolute;
  top: 0;
  left: 0;
  margin: ${({ theme }) => theme.spacing.margin}px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 15;
  outline: none;
  @media ${({ theme }) => theme.breakpoints.desktop} {
    visibility: hidden;
  }
  span {
    width: 2rem;
    height: 0.25rem;
    background: ${({ theme }) => theme.colors.main};
    border-radius: 10px;
    transition: all 0.2s linear;
    position: relative;
    transform-origin: 1px;
    :first-child {
      transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }
    :nth-child(2) {
      opacity: ${({ open }) => open ? '0' : '1'};
      
    }
    :nth-child(3) {
      transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }
`;

export const BurgerButton = (props: BurgerButtonProps) => {
  return (
    <StyledBurgerButton
      onClick={props.onClick}
      open={props.open}>
      <span />
      <span />
      <span />
    </StyledBurgerButton>
  )
}
